import { openDB, IDBPDatabase } from 'idb';
import DBConfig from '../DBConfig';

let dbPromise: Promise<IDBPDatabase<any>> | null = null;

export function initDB() {
  if (!dbPromise) {
    dbPromise = openDB(DBConfig.name, DBConfig.version, {
      upgrade(db) {
        for (const storeMeta of DBConfig.objectStoresMeta) {
          if (!db.objectStoreNames.contains(storeMeta.store)) {
            const os = db.createObjectStore(storeMeta.store, storeMeta.storeConfig);
            storeMeta.storeSchema.forEach((schema: any) => {
              os.createIndex(schema.name, schema.keypath, schema.options);
            });
          }
        }
      },
    });
  }
  return dbPromise;
}

export async function getTokenizedByTkID(tkID: string) {
  const db = await initDB();
  return db.getFromIndex('tokenized', 'tokenizedID', tkID);
}

export async function addTokenized(record: any) {
  const db = await initDB();
  return db.add('tokenized', record);
}
